'use client';
/** @jsxImportSource @emotion/react */

import type { TableFooterProps as MuiTableFooterProps } from '@mui/material/TableFooter';

import MuiTableFooter from '@mui/material/TableFooter';

type ExcludedMuiProps = '';

interface TableFooterProps extends Omit<MuiTableFooterProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { TableFooterProps };
export const TableFooter: React.FC<TableFooterProps> = MuiTableFooter;

TableFooter.displayName = 'TableFooter';
